import { useState } from 'react'
import { ArrowRight, LockKeyhole, ShieldCheck, WifiOff } from 'lucide-react'
import { useAdminAuth } from '../auth/AdminAuthProvider'
import { usePwaLifecycle } from '../lib/pwa'

export default function LoginPage() {
  const auth = useAdminAuth()
  const pwa = usePwaLifecycle()
  const [error, setError] = useState('')
  const [viewerPassword, setViewerPassword] = useState('')
  const [viewerBusy, setViewerBusy] = useState(false)
  const [busy, setBusy] = useState(false)

  async function login() {
    setBusy(true)
    setError('')
    try { await auth.login() } catch (err) { setError(err?.message || '로그인하지 못했습니다.') } finally { setBusy(false) }
  }

  async function loginViewer(event) {
    event.preventDefault()
    setViewerBusy(true)
    setError('')
    try {
      await auth.loginViewer(viewerPassword)
      setViewerPassword('')
    } catch {
      setError('비밀번호가 올바르지 않습니다.')
    } finally { setViewerBusy(false) }
  }

  if (['loading', 'checking'].includes(auth.status)) return null

  return (
    <main className="login-page">
      <section className="login-brand">
        <div className="brand-mark"><ShieldCheck size={29} /></div>
        <p className="eyebrow">SU-GUIDE OPERATIONS</p>
        <h1>운영에 필요한 정보만,<br />한 화면에서 명확하게.</h1>
        <p>사용자 앱과 완전히 분리된 SU-Guide 관리자 전용 워크스페이스입니다.</p>
        <div className="login-security"><LockKeyhole size={18} /><span>Firebase Custom Claim과 서버 규칙으로 권한을 확인합니다.</span></div>
      </section>
      <section className="login-panel">
        <div>
          <p className="eyebrow">ADMIN SIGN IN</p>
          <h2>관리자 로그인</h2>
          <p className="muted">등록된 운영 계정으로 계속하세요.</p>
        </div>
        <button className="button primary login-button" type="button" onClick={login} disabled={busy || !pwa.online || auth.status === 'configuration-error'}>
          <span>{busy ? '카카오 로그인으로 이동 중…' : '카카오 계정으로 계속'}</span><ArrowRight size={18} />
        </button>
        <div className="login-divider" aria-hidden="true"><span>또는</span></div>
        <form onSubmit={loginViewer} aria-label="팀원 읽기 전용 로그인">
          <p className="eyebrow">TEAM VIEWER</p>
          <p className="muted">팀원 읽기 전용</p>
          <label className="sr-only" htmlFor="viewer-password">읽기 전용 비밀번호</label>
          <input
            id="viewer-password"
            className="viewer-password-input"
            type="password"
            value={viewerPassword}
            onChange={event => setViewerPassword(event.target.value)}
            placeholder="비밀번호"
            autoComplete="current-password"
            disabled={viewerBusy || busy || !pwa.online || auth.status === 'configuration-error'}
          />
          <button className="button secondary login-button" type="submit" disabled={viewerBusy || busy || !viewerPassword || !pwa.online || auth.status === 'configuration-error'}>
            <span>{viewerBusy ? '접속 중…' : '접속'}</span><ArrowRight size={18} />
          </button>
        </form>
        {!pwa.online && <p className="temporary-warning" role="status"><WifiOff size={15} /> 네트워크 연결 후 관리자 로그인을 다시 시도하세요.</p>}
        {error && <p className="form-error" role="alert">{error}</p>}
        {auth.status === 'configuration-error' && <p className="form-error">Firebase 공개 클라이언트 설정이 올바르지 않습니다.</p>}
      </section>
    </main>
  )
}
